// extracted by mini-css-extract-plugin
export default {"ConnectionsBtn":"CompaniesNetworkButton_ConnectionsBtn__BOEFm","ConnectionsBtnContainer":"CompaniesNetworkButton_ConnectionsBtnContainer__u4nzE"};